//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AccountNavigation from "./account-navigation";
import ProfileContainer from "./profile-container";
import PersonalDetailsContainer from "./personal-details-container";
import EmailPreferencesContainer from "./email-preferences-container";
import FilogixDetailsContainer from "./filogix-details-container";
import RecurringRemindersContainer from "./recurring-reminders-container";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountContainer",
  components: {
    AccountNavigation,
    ProfileContainer,
    PersonalDetailsContainer,
    EmailPreferencesContainer,
    FilogixDetailsContainer,
    RecurringRemindersContainer
  },
  props: {
    accountPage: {
      type: String,
      default: null
    },
    saving: {
      type: Boolean,
      required: true
    },
    allowSave: {
      type: Boolean,
      required: true
    },
    nylasAccount: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentPage: this.accountPage || this.$route.meta.childrenTab || "profile"
    };
  },
  methods: {
    handlePageChange(page) {
      this.$emit("page-change", page);
      this.currentPage = page;
      this.$emit("allow-save", false);
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", allowSave);
    },
    handleFinishSaving(finishSaving) {
      this.$emit("finish-saving", finishSaving);
    }
  }
});